export const DECISIONS = [
  {
    id: 1,
    title: 'الموافقة على الميزانية التشغيلية للربع الثاني 2026',
    description: 'مراجعة وإقرار الميزانية التشغيلية للربع الثاني من العام المالي 2026، وتشمل: بنود المصروفات التشغيلية، الإيرادات المتوقعة، المشاريع الرأسمالية المقترحة، ومخصصات الطوارئ. تُقدّر الميزانية الإجمالية بـ 12.4 مليون ريال سعودي.',
    branch: 'شركة الفجر',
    creator: 'الرئيس التنفيذي',
    date: '2026-04-08',
    deadline: '2026-04-15',
    status: 'pending',
    attachments: [
      { name: 'الميزانية_التشغيلية_Q2.pdf', size: '2.4 MB', type: 'pdf' },
      { name: 'تقرير_المصروفات.xlsx',        size: '890 KB', type: 'excel' },
    ],
    votes: [
      { member: 'أحمد العمري',    vote: 'approve', note: 'أؤيد الميزانية المقدمة' },
      { member: 'محمد الزهراني',  vote: 'approve', note: '' },
      { member: 'فهد الحربي',     vote: 'reject',  note: 'أرى ضرورة مراجعة بنود المصروفات' },
      { member: 'سلطان القحطاني', vote: 'approve', note: 'موافق مع تحفظ على البند الثالث' },
    ],
    totalMembers: 10,
    myVote: null,
    myNote: '',
  },
  {
    id: 2,
    title: 'اعتماد عقد الشراكة مع شركة التقنية الرقمية',
    description: 'النظر في توقيع عقد شراكة استراتيجية لمدة 3 سنوات مع شركة التقنية الرقمية لتطوير منصة إلكترونية متكاملة لخدمات الشركة. تتضمن الشراكة: تطوير النظام، التدريب، والدعم الفني المستمر. القيمة الإجمالية للعقد 4.8 مليون ريال.',
    branch: 'شركة الفجر',
    creator: 'الرئيس التنفيذي',
    date: '2026-04-06',
    deadline: '2026-04-14',
    status: 'pending',
    attachments: [
      { name: 'عقد_الشراكة_الاستراتيجية.pdf', size: '1.8 MB', type: 'pdf' },
      { name: 'عرض_التقنية_الرقمية.pptx',      size: '5.2 MB', type: 'ppt' },
    ],
    votes: [
      { member: 'أحمد العمري',   vote: 'approve', note: 'استثمار ممتاز' },
      { member: 'تركي السلمي',   vote: 'reject',  note: 'العقد يحتاج مزيداً من المفاوضة' },
      { member: 'فهد الحربي',    vote: 'abstain', note: '' },
    ],
    totalMembers: 10,
    myVote: null,
    myNote: '',
  },
  {
    id: 3,
    title: 'تعيين مدير تنفيذي جديد للعمليات',
    description: 'مناقشة مقترح تعيين مدير تنفيذي للعمليات وإقرار المسمى الوظيفي والصلاحيات والراتب التنافسي للمنصب. المرشح المقترح يمتلك خبرة 18 عاماً في قطاع التشغيل والإدارة التنفيذية.',
    branch: 'شركة النور',
    creator: 'الرئيس التنفيذي',
    date: '2026-04-05',
    deadline: '2026-04-13',
    status: 'pending',
    attachments: [
      { name: 'السيرة_الذاتية_المرشح.pdf', size: '540 KB', type: 'pdf' },
    ],
    votes: [
      { member: 'عبدالرحمن الغامدي', vote: 'approve', note: '' },
      { member: 'بندر العنزي',        vote: 'approve', note: 'مرشح مميز' },
    ],
    totalMembers: 8,
    myVote: null,
    myNote: '',
  },
  {
    id: 4,
    title: 'توزيع أرباح الربع الأول 2026',
    description: 'إقرار توزيع أرباح الربع الأول من العام الجاري بنسبة 8% على حاملي الأسهم المسجّلين حتى تاريخ الإغلاق 2026/03/31. إجمالي المبالغ الموزعة 3.2 مليون ريال.',
    branch: 'شركة الفجر',
    creator: 'الرئيس التنفيذي',
    date: '2026-03-28',
    deadline: '2026-04-05',
    status: 'approved',
    attachments: [
      { name: 'تقرير_الأرباح_Q1.pdf',       size: '1.1 MB', type: 'pdf' },
      { name: 'قائمة_المساهمين_المؤهلين.xlsx', size: '430 KB', type: 'excel' },
    ],
    votes: [
      { member: 'أحمد العمري',    vote: 'approve', note: '' },
      { member: 'محمد الزهراني',  vote: 'approve', note: 'قرار صائب' },
      { member: 'فهد الحربي',     vote: 'approve', note: '' },
      { member: 'سلطان القحطاني', vote: 'approve', note: '' },
      { member: 'تركي السلمي',    vote: 'approve', note: 'أؤيد بالكامل' },
      { member: 'بندر العنزي',    vote: 'abstain', note: '' },
    ],
    totalMembers: 10,
    myVote: 'approve',
    myNote: 'أؤيد التوزيع بالكامل',
  },
  {
    id: 5,
    title: 'تعديل النظام الأساسي للشركة — المادة 12',
    description: 'مقترح بتعديل المادة 12 من النظام الأساسي المتعلقة بصلاحيات مجلس الإدارة وآليات اتخاذ القرار، لتشمل توسيع نطاق الصلاحيات التفويضية للمدير التنفيذي.',
    branch: 'شركة التقدم',
    creator: 'الرئيس التنفيذي',
    date: '2026-03-20',
    deadline: '2026-03-27',
    status: 'rejected',
    attachments: [
      { name: 'مقترح_تعديل_النظام_الأساسي.pdf', size: '780 KB', type: 'pdf' },
    ],
    votes: [
      { member: 'أحمد العمري',    vote: 'reject',  note: 'أرى أن الوقت غير مناسب' },
      { member: 'محمد الزهراني',  vote: 'reject',  note: 'يحتاج مزيداً من الدراسة' },
      { member: 'فهد الحربي',     vote: 'approve', note: '' },
      { member: 'تركي السلمي',    vote: 'reject',  note: '' },
    ],
    totalMembers: 10,
    myVote: 'reject',
    myNote: 'أرى أن الوقت غير مناسب',
  },
  {
    id: 6,
    title: 'الموافقة على خطة التوسع الجغرافي 2026',
    description: 'دراسة خطة التوسع الجغرافي في المنطقة الشرقية وفتح فرعين جديدين بتكلفة إجمالية تقديرية 6.5 مليون ريال. يُتوقع أن يرفع التوسع الإيرادات السنوية بنسبة 22%.',
    branch: 'شركة الريادة',
    creator: 'الرئيس التنفيذي',
    date: '2026-03-12',
    deadline: '2026-03-20',
    status: 'approved',
    attachments: [
      { name: 'دراسة_الجدوى_التوسع.pdf',   size: '3.1 MB', type: 'pdf' },
      { name: 'خطة_التوسع_2026.pptx',       size: '7.4 MB', type: 'ppt' },
      { name: 'تحليل_السوق_المنطقة_الشرقية.xlsx', size: '1.2 MB', type: 'excel' },
    ],
    votes: [
      { member: 'وليد المطيري',   vote: 'approve', note: 'قرار استراتيجي مهم' },
      { member: 'ماجد الدوسري',   vote: 'approve', note: '' },
      { member: 'راشد الشمري',    vote: 'abstain', note: 'أنتظر مزيداً من البيانات' },
    ],
    totalMembers: 8,
    myVote: 'abstain',
    myNote: '',
  },
];

export const VOTE_LABELS = {
  approve: { label: 'موافق', cls: 'status-badge--approved', iconName: 'check-circle', color: '#02c3a6' },
  reject: { label: 'رافض', cls: 'status-badge--rejected', iconName: 'x-circle', color: '#c62828' },
  abstain: { label: 'ممتنع', cls: 'status-badge--pending', iconName: 'clock', color: '#546e7a' },
};

/** Localized labels for approve / reject / abstain (vote chips, charts, tables). */
export function getVoteLabels(isAr) {
  return {
    approve: { ...VOTE_LABELS.approve, label: isAr ? 'موافق' : 'Approve' },
    reject: { ...VOTE_LABELS.reject, label: isAr ? 'رافض' : 'Reject' },
    abstain: { ...VOTE_LABELS.abstain, label: isAr ? 'ممتنع' : 'Abstain' },
  };
}

export const FILE_ICONS = {
  pdf:   { icon: '📄', color: '#e53935', bg: '#fce4ec' },
  excel: { icon: '📊', color: '#02c3a6', bg: '#e0f7f4' },
  ppt:   { icon: '📑', color: '#e65100', bg: '#fff3e0' },
  word:  { icon: '📝', color: '#02c3a6', bg: '#e0f7f4' },
};
